import {
    Ng2StateDeclaration,
    Transition,
    UIRouterModule
} from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { FixedPriceComponent } from '../fixed-price/components/fixed-price-tab/fixed-price.component';
import { GroupsService } from '../groups/groups.service';
import { GroupsFeatureComponent } from '../groups/feature/groups-feature.component';
import { GroupsPresentersComponent } from '../groups/presenters/groups-presenters.component';
import { CategoriesService } from '../shared/category/categories.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeCardModule } from '../timecard/time-card.module';
import { GroupsModule } from '../groups/groups.module';
import { processResolver } from './process-resolver';

const log = new LoggingService();

export const GroupsRoute: Ng2StateDeclaration = {
    name: 'groups',
    url: '/groups',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: GroupsFeatureComponent
};

@NgModule({
    imports: [
        CommonModule,
        GroupsModule,
        UIRouterModule.forChild({
            states: [
                {
                    name: 'roles',
                    url: '/roles',
                    data: { requiresAuth: true },
                    params: { process: {} },
                    resolve: [
                        {
                            token: 'process',
                            deps: [Transition, CategoriesService],
                            resolveFn: processResolver
                        }
                    ],
                    component: GroupsFeatureComponent
                },
                {
                    name: 'roles.administrator',
                    url: '/administrator',
                    component: GroupsFeatureComponent
                },
                {
                    name: 'roles.supervisor',
                    url: '/supervisor',
                    component: GroupsFeatureComponent
                },
                {
                    name: 'roles.taskmanager',
                    url: '/taskmanager',
                    component: GroupsFeatureComponent
                },
                {
                    name: 'roles.reportadmin',
                    url: '/reportadmin',
                    component: GroupsFeatureComponent
                },
                {
                    name: 'roles.subcontractor',
                    url: '/subcontractor',
                    component: GroupsFeatureComponent
                },
                GroupsRoute
            ]
        })
    ]
})
export class RolesGroupsRoutingModule {}
